export enum QUESTIONNAIRE_ANSWER_TYPES {
  RADIO = 'RADIO',
  BOOLEAN = 'BOOLEAN',
  DROPDOWN = 'DROPDOWN',
  DURATION = 'DURATION',
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA',
  MULTI_SELECT = 'MULTI_SELECT',
  NUMBER = 'NUMBER',
  RATING = 'RATING',
}

export enum QUESTIONNAIRE_RECRUITMENT_TYPES {
  SCHOOL_LEAVER = 'School Leaver',
  SALES_INDUSTRY_PROFESSIONAL = 'Sales Industry Professional',
  NON_SALES_INDUSTRY_PROFESSIONAL = 'Non-Sales Industry Professional',
}

export enum QUESTIONNAIRE_STATUSES {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export enum QUESTIONNAIRE_HISTORY_REASONS {
  ANSWERED = 'ANSWERED',
  EDITED = 'EDITED',
  RECRUITMENT_TYPE_CHANGED = 'RECRUITMENT_TYPE_CHANGED',
}
